import { RootState } from 'modules/store';
import { createSlice } from '@reduxjs/toolkit';
import { OIDCState } from './oidc.types';
import { getOIDCRegistrationData, registerForOIDC } from './oidc.actions';

const initialState: OIDCState = {
  isPending: false,
  isLoading: false,
  data: {
    lean_redirect_url: '',
    oidc_provider_base_url: '',
  },
};

const oidcSlice = createSlice({
  name: 'oidc',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getOIDCRegistrationData.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(getOIDCRegistrationData.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
    });
    builder.addCase(getOIDCRegistrationData.rejected, state => {
      state.isLoading = false;
    });

    builder.addCase(registerForOIDC.pending, state => {
      state.isPending = true;
    });
    builder.addCase(registerForOIDC.fulfilled, (state, { payload }) => {
      state.isPending = false;
      state.data = payload;
    });
    builder.addCase(registerForOIDC.rejected, state => {
      state.isPending = false;
    });
  },
});

export const oidc = oidcSlice.reducer;
export const selectOidc = (state: RootState) => state.root.oidc;
